export default class UserLoginRegisterModalHandler {
    constructor() {
        this.eventDelegation();
    };

    eventDelegation() {
        if (!document.querySelector('[data-open="login-user"]')) return;
        document.querySelectorAll('[data-open="login-user"]').forEach((element) => {
            element.addEventListener('click', () => {
                this.openLoginModal();
            });
        });

        if (!document.querySelector('[data-open="login-anchor-register"]')) return;
        document.querySelector('[data-open="login-anchor-register"]').addEventListener('click', () => {
            this.openLoginModal();
        });

        document.querySelectorAll('[data-open="registerAnchor"]').forEach((e) => {
            e.addEventListener('click', () => {
                this.openRegisterModal();
            });
        });

        document.querySelectorAll('[name="forgot-password"]').forEach((e) => {
            e.addEventListener('click', () => {
                this.openRememberPasswordModal();
            });
        });

        document.querySelectorAll('[data-open="loginAnchor"]').forEach((e) => {
            e.addEventListener('click', () => {
                this.openLoginModal();
            });
        });

        document.querySelector('#form-user-register').addEventListener('onFormSubmitted', (event, data) => {
            this.registedSubmittedData = data;
        });
    };

    openLoginModal() {
        this._showLoginInfo();
        this._hideRegisterInfo();
        this._hideRememberPasswordInfo();
        this._hideLoginActiveUser();

    }

    openRegisterModal() {
        this._showRegisterInfo();
        this._hideLoginInfo();
        this._hideRememberPasswordInfo();
        this._hideLoginActiveUser();
    }

    openRememberPasswordModal() {
        this._showRememberPasswordInfo();
        this._hideLoginInfo();
        this._hideRegisterInfo();
        this._hideLoginActiveUser();
    }

    openActiveUserModal() {
        this._showLoginActiveUser();
        this._hideRegisterInfo();
        this._hideRememberPasswordInfo();
    }

    _showLoginInfo() {
        document.querySelector('[data-container="login-user-header"]').style.display = '';
        document.querySelector('[data-container="form-login-user"]').style.display = '';
        document.querySelector('[data-container="form-response-form-user-login"]').style.display = 'none';
        const registerButton = document.querySelector('[data-entity="form-user-login-button"]');
        registerButton.disabled = false;
        registerButton.classList.remove('disabled');
    }

    _hideLoginInfo() {
        document.querySelector('[data-container="login-user-header"]').style.display = 'none';
        document.querySelector('[data-container="form-login-user"]').style.display = 'none';
        document.querySelector('[data-container="form-response-form-user-login"]').style.display = 'none';
    }

    _showRegisterInfo() {
        document.querySelector('[data-container="register-user-header"]').style.display = '';
        document.querySelector('[data-container="form-register-user"]').style.display = '';
        document.querySelector('[data-container="form-response-form-user-register"]').style.display = 'none';
        const registerButton = document.querySelector('[data-entity="form-user-register-button"]');
        registerButton.disabled = false;
        registerButton.classList.remove('disabled');
    }

    _hideRegisterInfo() {
        document.querySelector('[data-container="register-user-header"]').style.display = 'none';
        document.querySelector('[data-container="form-register-user"]').style.display = 'none';
        document.querySelector('[data-container="form-response-form-user-register"]').style.display = 'none';
    }

    _showRememberPasswordInfo() {
        document.querySelector('[data-container="remember-password-header"]').style.display = '';
        document.querySelector('[data-container="form-remember-password-user"]').style.display = '';
        document.querySelector('[data-container="form-response-form-user-remember-password"]').style.display = 'none';
        const registerButton = document.querySelector('[data-entity="form-user-remember-password-button"]');
        registerButton.disabled = false;
        registerButton.classList.remove('disabled');
    }

    _hideRememberPasswordInfo() {
        document.querySelector('[data-container="remember-password-header"]').style.display = 'none';
        document.querySelector('[data-container="form-remember-password-user"]').style.display = 'none';
        document.querySelector('[data-container="form-response-form-user-remember-password"]').style.display = 'none';
    }

    _showLoginActiveUser() {
        this._showLoginInfo();
        document.querySelector('#externalServices').style.display = 'none';
        document.querySelector('#footerLogin').style.display = 'none';
        document.querySelector('#loginFormHeader').style.display = 'none';
        document.querySelector('[data-attr="info-active-account"]').style.display = '';
        document.querySelector('[data-container="login-user-header"]').innerHTML = myApp.translator['user.login_page.register.hello'].replace('%name%', activateAccountInfo['userName']);
    }

    _hideLoginActiveUser() {
        document.querySelector('#externalServices').style.display = '';
        document.querySelector('#footerLogin').style.display = '';
        document.querySelector('#loginFormHeader').style.display = '';
        document.querySelector('[data-attr="info-active-account"]').style.display = 'none';
        document.querySelector('[data-container="login-user-header"]').innerHTML = myApp.translator['user.login_page.login.short_head'];
    }
};
